import Users from './Users.Container';

export default Users;
